import { render, staticRenderFns } from "./CartResume.vue?vue&type=template&id=4e4a0ece&scoped=true&"
import script from "./CartResume.vue?vue&type=script&lang=js&"
export * from "./CartResume.vue?vue&type=script&lang=js&"
import style0 from "./CartResume.vue?vue&type=style&index=0&id=4e4a0ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a0ece",
  null
  
)

export default component.exports